import { render, staticRenderFns } from "./VTextFieldDatePicker.vue?vue&type=template&id=4006e3cf&scoped=true"
import script from "./VTextFieldDatePicker.vue?vue&type=script&lang=js"
export * from "./VTextFieldDatePicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4006e3cf",
  null
  
)

export default component.exports